(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptCompendiumDefaultMessage', RptCompendiumDefaultMessage);

    RptCompendiumDefaultMessage.$inject = ['$resource'];

    function RptCompendiumDefaultMessage ($resource) {
        var resourceUrl =  'api/rpt-compendium-default-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'init': {method: 'GET', url: 'api/rpt-compendium-default-messages/init-clinic/:id'}
        });
    }
})();
